<template>
  <footer>
<!--    <span style="display:inline-block;text-decoration:none;height:40px;line-height:40px;">Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号</span>-->
    <!--<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802010409" style="display:inline-block;text-decoration:none;height:40px;line-height:40px;"><img src="../../assets/footer.png" style="vertical-align: text-bottom" />-->
      <!--<span style="height:40px;line-height:40px;margin: 0 0 0 5px; color:#939393;">浙公网安备 33010802010409号</span >-->
    <!--</a>-->
  </footer>
</template>

<script>
export default {
  name: 'foot-text'
}
</script>

<style scoped>
footer {
  width: 100%;
  font-size: 14px;
  text-align: center;
  color: #999;
  background-color: #eff1f5;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/FootText/FootText.vue